import { PrivilegeTypes } from '@bringg/types';

import { useHasAccess } from '../utils/privileges';
import { useHasFeatureFlag } from '../utils/feature-flags';

export interface DriverProfileAccess {
	canView: boolean;
	canEdit: boolean;
	// Mirrors sharedAccessConfig.driverProfile route access in app.js: driver profile v2 view/edit,
	// or the dispatchers page (dispatcher_new_side_menu_items FF + dispatcher profile view/edit).
	canAccess: boolean;
}

export const useDriverProfileAccess = (): DriverProfileAccess => {
	const canEdit = useHasAccess(PrivilegeTypes.DRIVER_PROFILE_V2, PrivilegeTypes.DRIVER_PROFILE_V2_EDIT);
	const canView = useHasAccess(PrivilegeTypes.DRIVER_PROFILE_V2, PrivilegeTypes.DRIVER_PROFILE_V2_VIEW);
	const isDispatcherSideMenuEnabled = useHasFeatureFlag('dispatcher_new_side_menu_items');
	const canEditDispatcherProfile = useHasAccess(
		PrivilegeTypes.DISPATCHER_PROFILE,
		PrivilegeTypes.DISPATCHER_PROFILE_EDIT
	);
	const canViewDispatcherProfile = useHasAccess(
		PrivilegeTypes.DISPATCHER_PROFILE,
		PrivilegeTypes.DISPATCHER_PROFILE_VIEW
	);

	return {
		canView,
		canEdit,
		canAccess:
			canView ||
			canEdit ||
			(isDispatcherSideMenuEnabled && (canEditDispatcherProfile || canViewDispatcherProfile))
	};
};
